




























































































































































































































































































































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, State, Mutation} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BCheckbox from 'buefy/src/components/checkbox/Checkbox.vue'; // @ is an alias to /src

import BSelect from 'buefy/src/components/select/Select.vue';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker.vue';
import {MAFUser} from '@/store/User/types';
import {Lookup} from '@/store/types'; // @ is an alias to /src
import * as luxon from 'luxon';
import Slider from '../common/Slider.vue';
import {OptionType} from '@/components/common/types';

const namespace = 'userState';

@Component({
    components: {
        BDatepicker,
        BField,
        BButton,
        BInput,
        BSelect,
        Slider,
        BCheckbox,
    },
})
export default class Terms extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @State('diagnosis', {namespace}) public diagnosis: Lookup | undefined;
    @State('userType', {namespace}) public userType: Lookup | undefined;

    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

    public accepted: boolean;
    public BASE_URL: string;
    public update: MAFUser;
    public acceptMessage: string;
    public isLoading: boolean;

    constructor() {
        super();
        this.acceptMessage = '';
        this.accepted = false;
        this.isLoading = false;
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update = this.self;
    }

    public async submit(event: any) {
        event.preventDefault();

        this.isLoading = true;
        this.update.signUpPhase = -1;
        this.update.termsAgreedOn = new Date();

        try {
            await this.updateSelfDoc(this.update.toPlainObj());
            this.setSelf(this.update);
        } catch (error) {
            this.$snackbar.open({
                message: 'Error saving user please try again.',
                type: 'is-danger',
                indefinite: true,
            });
        }

        this.isLoading = false;
    }

}
